import { memo } from 'react'
import cn from 'classnames'

import type { TextProps } from './types'

import styles from './Text.module.scss'

/** Единственный компонент типографики продукта. Числовых размеров в пропсах нет. */
export const Text = memo(function Text(props: TextProps) {
  const {
    variant = 'BODY',
    color = 'PRIMARY',
    align,
    as: Component = 'span',
    truncate = false,
    clampLines,
    children,
  } = props

  return (
    <Component
      className={cn(
        styles.root,
        styles[`variant_${variant}`],
        styles[`color_${color}`],
        align && styles[`align_${align}`],
        truncate && styles.truncate,
        clampLines && styles[`clamp_${clampLines}`],
      )}
    >
      {children}
    </Component>
  )
})
